import React from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { ButtonBase, Fab, IconButton, Grid, Tooltip, makeStyles } from '@material-ui/core'
import { PinDrop, Close } from '@material-ui/icons'
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos'

import { useLiterals } from '~/components/Literals'

import { formatDistance } from '~/utils'
import { selectStores } from '~/selectors'

import actions from '~/actions'

const useStyles = makeStyles((theme) => ({
  close: {
    position: 'absolute',
    top: 4,
    right: 4,
  },
  boxRoute: {
    display: 'flex',
    position: 'relative',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    borderLeft: `1px solid ${theme.palette.divider}`,
  },
  buttonRoute: {
    width: 71,
    height: 71,
    marginBottom: 15,
    backgroundColor: '#F2F2F2',
    boxShadow: '0px 1px 2px #00000029',
  },
  contentRoute: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    textTransform: 'initial',
  },
}))

function ButtonStoreRoute({ mapRouteCommunProps, isMobile }) {
  const dispatch = useDispatch()
  const classes = useStyles()

  const { currentStore } = useSelector(selectStores)
  const { getLiteral } = useLiterals()

  return (
    <Grid className={classes.boxRoute} style={{ padding: isMobile ? '0 16px' : '32px 24px' }}>
      {!isMobile && (
        <Tooltip title={getLiteral('1251')} placement="bottom">
          <IconButton
            aria-label={getLiteral('1251')}
            size="small"
            className={classes.close}
            onClick={() => dispatch(actions.showStoreInformation(false))}
          >
            <Close />
          </IconButton>
        </Tooltip>
      )}

      <Fab {...mapRouteCommunProps} className={classes.buttonRoute}>
        <Grid className={classes.contentRoute}>
          <PinDrop color="primary" />
          {formatDistance(currentStore?.distance || 0)}
        </Grid>
      </Fab>
      <ButtonBase {...mapRouteCommunProps}>
        <span style={{ textDecoration: isMobile ? 'none' : 'underline' }}>{getLiteral('2474')}</span>
        {isMobile && <ArrowForwardIosIcon style={{ color: '#698387', fontSize: 14, marginTop: 2, marginLeft: 2 }} />}
      </ButtonBase>
    </Grid>
  )
}

export default ButtonStoreRoute
